import JobLayout from 'components/JobLayout';
import ApplyHeader from 'pages/StartApplication/components/ApplyHeader';
import ApplyProvider from 'pages/StartApplication/components/ApplyProvider';
import JobLockedModal from 'pages/StartApplication/components/JobLockedModal';
import JobLockedModalContext from 'pages/StartApplication/components/JobLockedModal/Context';
import useJobLockedModal from 'pages/StartApplication/components/JobLockedModal/useJobLockedModal';
import { Details as ApplyDetails } from '@kanda-libs/ks-apply';
import { Button } from '@kanda-libs/ks-design-library';
import { useCurrentUser } from '@kanda-libs/ks-frontend-services';
import { FunctionComponent } from 'react';

const Details: FunctionComponent = function () {
  const { locked, showModal } = useJobLockedModal();
  const { isUserLoggedIn } = useCurrentUser();

  const showAltButton = !isUserLoggedIn || locked;

  return (
    <JobLockedModalContext.Provider value={{ locked, showModal }}>
      <ApplyProvider>
        <JobLayout header={<ApplyHeader />} showJobCard={false}>
          <>
            <ApplyDetails
              tickItems={[
                'Response in less than 60 seconds',
                "Checking eligibility won't affect your credit score",
                'Once complete, accept or decline your quote',
              ]}
              alternateButton={
                showAltButton ? (
                  <Button.Text
                    id="checkout-not-signed-in"
                    label="Next"
                    icon="arrow-right"
                    className="w-full mt-8"
                    variant="gradient"
                    onClick={() => showModal()}
                  />
                ) : undefined
              }
            />
            <JobLockedModal />
          </>
        </JobLayout>
      </ApplyProvider>
    </JobLockedModalContext.Provider>
  );
};

export default Details;
